var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { IsDateString, IsNumber, IsOptional, IsString, IsUUID } from 'class-validator';
export class UpdateTrainingSessionDto {
    id;
    started;
    ended;
    evalNotes;
    evalMood;
    difficulty;
    evaluated;
}
__decorate([
    IsUUID(),
    IsOptional(),
    __metadata("design:type", String)
], UpdateTrainingSessionDto.prototype, "id", void 0);
__decorate([
    IsDateString(),
    IsOptional(),
    __metadata("design:type", Object)
], UpdateTrainingSessionDto.prototype, "started", void 0);
__decorate([
    IsDateString(),
    IsOptional(),
    __metadata("design:type", Object)
], UpdateTrainingSessionDto.prototype, "ended", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", Object)
], UpdateTrainingSessionDto.prototype, "evalNotes", void 0);
__decorate([
    IsNumber(),
    IsOptional(),
    __metadata("design:type", Object)
], UpdateTrainingSessionDto.prototype, "evalMood", void 0);
__decorate([
    IsOptional(),
    IsNumber(),
    __metadata("design:type", Object)
], UpdateTrainingSessionDto.prototype, "difficulty", void 0);
__decorate([
    IsDateString(),
    IsOptional(),
    __metadata("design:type", Object)
], UpdateTrainingSessionDto.prototype, "evaluated", void 0);
//# sourceMappingURL=update-training-session.dto.js.map